import React from "react";
import { useTranslation } from "react-i18next";
import styled, { css } from "styled-components";
import { IconButton } from "components/common";
const Title = styled.div(
  ({ theme }) => css`
    display: flex;
    gap: ${theme.spacings.xs};
    align-items: center;
    min-height: 25px; // as icon button
  `
);
const StyledIconButton = styled(IconButton)(
  ({ theme }) => css`
    position: absolute;
    left: 0;
    color: ${theme.colors.text.primary};
  `
);
const StyledLabel = styled.span(
  ({ theme }) => css`
    margin-left: ${theme.spacings.sm};
  `
);
const PopoverTitle = ({ children = null, onBackClick = false }) => {
  const { t } = useTranslation("aggregation");
  return /* @__PURE__ */ React.createElement(Title, null, onBackClick && /* @__PURE__ */ React.createElement(StyledIconButton, { size: "xs", name: "arrow_back", title: t("vis_popover.back"), onClick: onBackClick }), /* @__PURE__ */ React.createElement(StyledLabel, null, children));
};
export default PopoverTitle;
